import React from 'react';

 const ArrowLeft =  (props) => (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.3763 11.1707L6.74036 11.7777C6.47109 12.0348 6.03567 12.0348 5.76927 11.7777L0.200519 6.46485C-0.068752 6.20782 -0.068752 5.79219 0.200519 5.53789L5.76927 0.222269C6.03854 -0.0347626 6.47396 -0.0347626 6.74036 0.222269L7.3763 0.8293C7.64843 1.08907 7.64271 1.51289 7.36484 1.76719L3.91302 4.90625H12.1458C12.5268 4.90625 12.8333 5.19883 12.8333 5.5625V6.4375C12.8333 6.80117 12.5268 7.09375 12.1458 7.09375H3.91302L7.36484 10.2328C7.64557 10.4871 7.6513 10.9109 7.3763 11.1707Z" fill="#2C628A"/>
    </svg>

);
export default ArrowLeft